import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

const PRIVACY_URL = 'https://www.ford.hu/hasznos-informaciok/terms-and-privacy-policy-hub';
const COOKIE_GUIDE_URL = 'https://www.ford.hu/hasznos-informaciok/terms-and-privacy-policy-hub/cookies-guide';

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function updateGtmConsent(cookie) {
  const accepted = (cookie && cookie.categories) || [];
  gtag('consent', 'update', {
    analytics_storage:  accepted.includes('analytics') ? 'granted' : 'denied',
    ad_storage:         accepted.includes('marketing') ? 'granted' : 'denied',
    ad_user_data:       accepted.includes('marketing') ? 'granted' : 'denied',
    ad_personalization: accepted.includes('marketing') ? 'granted' : 'denied',
  });
}

const CONFIG = {
  cookie: { name: 'cc_cookie' },

  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom right',
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: 'box',
      position: 'right',
      equalWeightButtons: true,
      flipButtons: false,
    },
  },

  onFirstConsent: ({ cookie }) => updateGtmConsent(cookie),
  onConsent:      ({ cookie }) => updateGtmConsent(cookie),
  onChange:       ({ cookie }) => updateGtmConsent(cookie),

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {
      autoClear: {
        cookies: [
          { name: /^_ga/ },
          { name: '_gid' },
        ],
      },
    },
    marketing: {
      autoClear: {
        cookies: [
          { name: '_gcl_au' },
          { name: '_fbp' },
          { name: 'fr' },
        ],
      },
    },
  },

  language: {
    default: 'hu',
    translations: {
      hu: {
        consentModal: {
          title: 'Sütiket használunk',
          description: `A weboldal megfelelő működéséhez szükséges sütiket mindig használjuk. Az analitikai és marketing sütik csak az Ön hozzájárulásával aktiválódnak. Bármikor módosíthatja a beállításait. <a href="${PRIVACY_URL}" target="_blank">További információ a Feltételek és adatvédelem oldalon</a>.`,
          acceptAllBtn: 'Összes elfogadása',
          acceptNecessaryBtn: 'Csak szükséges',
          showPreferencesBtn: 'Beállítások kezelése',
          footer: `<a href="${PRIVACY_URL}" target="_blank">Feltételek és adatvédelem</a>`,
        },
        preferencesModal: {
          title: 'Süti beállítások',
          acceptAllBtn: 'Összes elfogadása',
          acceptNecessaryBtn: 'Csak szükséges',
          savePreferencesBtn: 'Beállítások mentése',
          closeIconLabel: 'Bezárás',
          serviceCounterLabel: 'Szolgáltatás|Szolgáltatások',
          sections: [
            {
              title: 'A sütik használata',
              description: 'A sütiket a felhasználói élmény javítására, az oldal teljesítményének méréséhez és személyre szabott tartalmak megjelenítéséhez használjuk. Az alábbi kategóriákban szabhatja testre a hozzájárulását.',
            },
            {
              title: 'Szükséges sütik <span class="pm__badge">Mindig aktív</span>',
              description: 'Az oldal alapvető működéséhez szükségesek (munkamenet, kedvencek és összehasonlítás, CSRF-védelem). Ezek nem kapcsolhatók ki.',
              linkedCategory: 'necessary',
              cookieTable: {
                headers: { name: 'Név', domain: 'Domain', desc: 'Leírás' },
                body: [
                  { name: '_ford_stock_session', domain: 'fordkeszlet.hu', desc: 'Munkamenet-azonosító, a keresési beállítások, a kedvencek és az összehasonlítási lista fenntartásához.' },
                  { name: 'cc_cookie',           domain: 'fordkeszlet.hu', desc: 'Az Ön süti-hozzájárulási döntésének tárolása.' },
                ],
              },
            },
            {
              title: 'Analitikai sütik',
              description: 'Segítenek megérteni, hogyan használják látogatóink az oldalt (Google Analytics 4).',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: { name: 'Név', domain: 'Domain', desc: 'Leírás', exp: 'Lejárat' },
                body: [
                  { name: '_ga',   domain: 'fordkeszlet.hu', desc: 'Google Analytics — egyedi látogatóazonosító.', exp: '2 év' },
                  { name: '_ga_*', domain: 'fordkeszlet.hu', desc: 'Google Analytics 4 — session állapot.',        exp: '2 év' },
                  { name: '_gid',  domain: 'fordkeszlet.hu', desc: 'Google Analytics — látogató-megkülönböztetés.', exp: '24 óra' },
                ],
              },
            },
            {
              title: 'Marketing sütik',
              description: 'Személyre szabott hirdetésekhez és remarketinghez (Google Ads, Meta Pixel).',
              linkedCategory: 'marketing',
              cookieTable: {
                headers: { name: 'Név', domain: 'Domain', desc: 'Leírás', exp: 'Lejárat' },
                body: [
                  { name: '_gcl_au', domain: 'fordkeszlet.hu', desc: 'Google Ads — konverzió-csatolás.',           exp: '3 hónap' },
                  { name: '_fbp',    domain: 'fordkeszlet.hu', desc: 'Meta Pixel — böngészőazonosító.',            exp: '3 hónap' },
                  { name: 'fr',      domain: '.facebook.com',  desc: 'Meta Pixel — hirdetés-relevancia és mérés.', exp: '3 hónap' },
                ],
              },
            },
            {
              title: 'További információ',
              description: `A süti-kezelési gyakorlatunkról bővebben a <a href="${COOKIE_GUIDE_URL}" target="_blank">süti-tájékoztatóban</a> olvashat.`,
            },
          ],
        },
      },
    },
  },
};

// The root lives in the layout marked `data-turbo-permanent`, so the banner survives
// Turbo navigations. If Turbo ever does replace it, the emptiness check re-runs setup.
function initCookieConsent() {
  const root = document.getElementById('cookie-consent-root');
  if (!root || root.childElementCount > 0) return;

  CookieConsent.run(Object.assign({ root: root }, CONFIG));
}

document.addEventListener('DOMContentLoaded', initCookieConsent);
document.addEventListener('turbo:load', initCookieConsent);

// Footer link (and anything else marked up the same way) reopens the preferences modal.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;

  event.preventDefault();
  CookieConsent.showPreferences();
});
